import * as React from "react";
import { Typography, Box, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
const Content = styled(Typography)`
  margin-bottom: 0.3rem;
`;
const DatePickers = ({ label, required, value, onChange, name,disabled }) => {
    const { t } = useTranslation();
    const handleChange = (event) => {
        const { value } = event.target;
        onChange(value);
    };
    return (
        <>
            <Content>
                <Typography required={required} color="#666666">
                    {t(label)}
                </Typography>
            </Content>
            <Box
                component="form"
                sx={{
                    "& .MuiTextField-root": { width: "100%" },
                }}
                noValidate
                autoComplete="off"
            >
                <TextField
                    id="date"
                    type="date"
                    name={name}
                    format = "DD-MM-YYYY"
                    disabled={disabled}
                    // defaultValue="2017-05-24"
                    defaultValue={value}
                    value={value}
                    // sx={{ width: 245 }}
                    size='small'
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    
                />
            </Box>
        </>
    );
}
export default DatePickers